(() => {
  if (customElements.get('homepage-credibility-scroller')) {
    return;
  }

  class HomepageCredibilityScroller extends HTMLElement {
    constructor() {
      super();
      this.viewport = null;
      this.primaryGroup = null;
      this.track = null;
      this.animationFrame = null;
      this.lastTimestamp = 0;
      this.loopWidth = 0;
      this.currentOffset = 0;
      this.baseDurationDesktop = 8.5;
      this.baseDurationMobile = 10.5;
      this.itemCount = 0;
      this.groupGap = 0;
      this.mediaQuery = window.matchMedia('(min-width: 768px)');
      this.handleResize = this.handleResize.bind(this);
      this.tick = this.tick.bind(this);
    }

    connectedCallback() {
      this.viewport = this.querySelector('[data-scroller-viewport]');
      this.primaryGroup = this.querySelector('[data-scroller-group]');
      this.track = this.querySelector('[data-scroller-track]');

      if (!this.viewport || !this.primaryGroup || !this.track || this.viewport.dataset.autoScroll !== 'true') {
        return;
      }

      this.baseDurationDesktop = Number(this.viewport.dataset.baseDurationDesktop || 8.5);
      this.baseDurationMobile = Number(this.viewport.dataset.baseDurationMobile || 10.5);
      this.itemCount = this.primaryGroup.children.length;

      this.updateLoopWidth();
      this.mediaQuery.addEventListener('change', this.handleResize);
      window.addEventListener('resize', this.handleResize);
      this.animationFrame = window.requestAnimationFrame(this.tick);
    }

    disconnectedCallback() {
      this.mediaQuery.removeEventListener('change', this.handleResize);
      window.removeEventListener('resize', this.handleResize);

      if (this.animationFrame) {
        window.cancelAnimationFrame(this.animationFrame);
        this.animationFrame = null;
      }
    }

    handleResize() {
      this.updateLoopWidth();
    }

    updateLoopWidth() {
      if (!this.primaryGroup) {
        return;
      }

      this.groupGap = this.track ? Number.parseFloat(window.getComputedStyle(this.track).columnGap || window.getComputedStyle(this.track).gap || '0') : 0;
      this.loopWidth = this.primaryGroup.getBoundingClientRect().width + this.groupGap;

      if (Math.abs(this.currentOffset) >= this.loopWidth && this.loopWidth > 0) {
        this.currentOffset = this.currentOffset + this.loopWidth;
      }

      if (this.track) {
        this.track.style.transform = `translate3d(${this.currentOffset}px, 0, 0)`;
      }
    }

    tick(timestamp) {
      if (!this.track || !this.loopWidth) {
        this.animationFrame = window.requestAnimationFrame(this.tick);
        return;
      }

      if (!this.lastTimestamp) {
        this.lastTimestamp = timestamp;
      }

      const elapsed = timestamp - this.lastTimestamp;
      this.lastTimestamp = timestamp;
      const baseDuration = this.mediaQuery.matches ? this.baseDurationDesktop : this.baseDurationMobile;
      const pixelsPerSecond = this.itemCount > 0 && baseDuration > 0
        ? this.loopWidth / (this.itemCount * (baseDuration / 2))
        : 0;
      this.currentOffset = this.currentOffset - (pixelsPerSecond * elapsed) / 1000;

      if (Math.abs(this.currentOffset) >= this.loopWidth) {
        this.currentOffset = this.currentOffset + this.loopWidth;
      }

      this.track.style.transform = `translate3d(${this.currentOffset}px, 0, 0)`;

      this.animationFrame = window.requestAnimationFrame(this.tick);
    }
  }

  customElements.define('homepage-credibility-scroller', HomepageCredibilityScroller);
})();